module.exports = __webpack_public_path__ + "img/icon_arrow_right.fc42af3b.svg";